<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span>{{ aLang.sd_title }}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="8">
              <b-row>
                <b-col md="12">
                  <el-form-item
                    :label="aLang.sd_csotf + (mData.dataForm.hoat_dong && mData.dataForm.hoat_dong.thoi_diem_thay_doi_cuoi ? ' (Lần thay đổi gần nhất: ' + new Intl.DateTimeFormat('vi-VN',options).format(new Date(mData.dataForm.hoat_dong.thoi_diem_thay_doi_cuoi)) + ')' : '')"
                    prop="ngung_hoat_dong"
                  >
                    <div class="form-css">
                      <el-radio
                        class="checkbox-active"
                        v-model='mData.dataForm.hoat_dong.ngung_hoat_dong'
                        @change="fn_chuyenTrangThaiHoatDong(false)"
                        :label="false"
                        :disabled="mData.notAllowToChange"
                      >{{aLang.sd_active}}</el-radio>
                      <el-radio
                        class="checkbox-inactive"
                        v-model='mData.dataForm.hoat_dong.ngung_hoat_dong'
                        @change="fn_chuyenTrangThaiHoatDong(true)"
                        :label="true"
                        :disabled="mData.notAllowToChange"
                      >{{aLang.sd_unactive}}</el-radio>
                    </div>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item :label="aLang.sd_safe_destination_type" prop="ten_loai_diem_den">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.ten_loai_diem_den"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <el-form-item :label="aLang.sd_safe_destination_name" prop>
                    <el-input
                      type="text"
                      v-model="mData.dataForm.thong_tin_chung.ten"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="4">
              <el-form-item class="mb-0" :label="aLang.sd_avatar">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit"
                  :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien"
                  :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien"
                  :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.sd_papers}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseGiayTo
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseGiayTo" visible>
                  <b-row>
                    <b-col md="3">
                      <el-form-item :label="aLang.sd_tax_code" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.giay_to.so_giay_to"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.sd_issued_by" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.giay_to.noi_cap"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.sd_date_range" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.giay_to.ngay_cap"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>

                    <b-col md="3">
                      <el-form-item :label="aLang.sd_address" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.giay_to.dia_chi"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="8">
                      <el-form-item
                        class="mb-0"
                        :label="aLang.sd_image_papers_scan"
                        prop
                        v-show="mData.viewMode != 'detail'"
                      >
                        <el-upload
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhGiayTo.limit"
                          :accept="mData.fileUploadOption.AnhGiayTo.accept"
                          :on-change="fn_uploadChangeAnhGiayTo"
                          :on-preview="fn_uploadPreviewAnhGiayTo"
                          :on-remove="fn_uploadRemoveAnhGiayTo"
                          :on-exceed="fn_uploadExceedAnhGiayTo"
                          multiple
                          :file-list="mData.fileUploadOption.AnhGiayTo.fileList"
                          :disabled="mData.viewMode == 'detail'"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhGiayTo.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhGiayTo.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                      <el-form-item
                        class="mb-0"
                        :label="aLang.sd_scanned_copy_of_business_registration"
                        prop
                        v-show="mData.viewMode == 'detail'"
                      >
                        <div class="row">
                          <div
                            :class="(item.type && item.type == 'Image') || !item.type ? 'col-md-3 text-center' : 'col-md-12'"
                            v-for="item in mData.fileUploadOption.AnhGiayTo.fileList"
                            :key="item.name"
                          >
                            <el-image
                              style="width: 100px; height: 100px"
                              :src="item.url"
                              :preview-src-list="mData.dataDefault.listImageUrl"
                              v-if="(item.type && item.type == 'Image') || !item.type"
                            >
                              <div slot="error" class="el-image__error">
                                <!-- <i class="el-icon-picture-outline"></i> -->
                                <span class="small" style="line-height:1rem;">{{item.name}}</span>
                              </div>
                            </el-image>
                            <el-link
                              type="info"
                              v-if="item.type && item.type != 'Image'"
                              @click="fn_download(item)"
                            >
                              <i class="el-icon-document"></i>
                              {{item.name}}
                            </el-link>
                            <el-button
                              v-if="(item.type && item.type == 'Image') || !item.type"
                              @click="fn_download(item)"
                              type="info"
                              size="small"
                              plain
                            >Tải về</el-button>
                          </div>
                        </div>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.sd_address}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseDiaChi
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiaChi" visible>
                  <b-row>
                    <b-col md="6">
                      <b-row>
                        <b-col md="6">
                          <el-form-item :label="aLang.sd_province" prop>
                            <el-select
                              v-model="mData.dataFormOther.dia_chi.tinh_id"
                              :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listProvince"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item :label="aLang.sd_commune" prop>
                            <el-select
                              v-model="mData.dataFormOther.dia_chi.xa_id"
                              :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listCommune"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item :label="aLang.sd_address" prop>
                            <el-input
                              type="text"
                              v-model="mData.dataFormOther.dia_chi.dia_chi"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col>
                          <mapbox-component-h300
                            :viewMode="mData.viewMode"
                            @update="fn_getDataFromMapboxComponent"
                            :cordinatesValue="mData.mapDataObject.value"
                            v-if="mData.dataDefault.showMap"
                            id="mapBox"
                          ></mapbox-component-h300>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center mb-2">
              <el-button
                type="info"
                plain
                @click="fn_handle('update', mData.dataForm.id, mData.dataForm)"
                v-ladda
                >{{aLang.rsd_update_unit_information}}</el-button
              >
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.sd_representative}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseNguoiDaiDien
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseNguoiDaiDien" visible>
                  <b-row>
                    <b-col md="6">
                      <el-form-item :label="aLang.sd_representative_name" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.ho_ten"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.sd_position" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.chuc_vu"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.sd_bod" prop>
                        <el-date-picker
                          type="datetime"
                          v-model="mData.dataFormOther.nguoi_dai_dien.ngay_sinh"
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                          :disabled="mData.viewMode == 'detail'"
                          :placeholder="aElement.datepicker.placeholderDate"
                        >clearable</el-date-picker>
                      </el-form-item>
                    </b-col>

                    <b-col md="3">
                      <el-form-item :label="aLang.sd_identification_code" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.so_giay_to"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.sd_gender" prop>
                        <el-select
                          v-model="mData.dataFormOther.nguoi_dai_dien.gioi_tinh"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listGioiTinh"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.sd_phone" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.dien_thoai"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.sd_email" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.email"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item :label="aLang.sd_address" prop>
                        <el-input
                          type="text"
                          v-model="mData.dataFormOther.nguoi_dai_dien.dia_chi"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <!-- <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.sd_safety_criteria}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseTieuChi
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseTieuChi" visible>
                  <b-row>
                    <b-col md="12">
                      <el-checkbox-group v-model="mData.dataDefault.listTieuChiAnToan">
                        <el-checkbox
                          v-for="item in mData.dataDefault.listTieuChiAnToan"
                          :label="item"
                          :key="item"
                          disabled
                        >{{item}}</el-checkbox>
                      </el-checkbox-group>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row> -->

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.rsd_album}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseAlbum
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseAlbum" visible>
                  <b-row class="mb-1">
                    <b-col md="3">
                      <el-form-item :label="aLang.ns_language" prop="ngon_ngu">
                        <el-select
                          v-model="mData.dataForm.ngon_ngu"
                          @change="fn_changeLanguage(mData.dataForm.ngon_ngu)"
                          :placeholder="aLang.c_select"
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listNgonNgu"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col md="12" class="d-flex">
                      <label class="label-image" style="margin-right: 10px;">ALBUM ẢNH</label>
                      <el-popover
                        style="color: #fff;"
                        placement="bottom-start"
                        width="300"
                        trigger="click"
                      >
                        <el-link href="javascript:" class="warning-text" slot="reference"><i class="el-icon-info" style="margin-right: 5px;"></i>Lưu ý khi tải ảnh</el-link>
                        <div class="alert-message">
                          <p>
                            Hình ảnh sau khi đăng tải sẽ được thay đổi kích thước để hiển thị phù hợp trên giao diện ứng dụng Du lịch Việt Nam an toàn.
                            Để chất lượng hình ảnh tối ưu nhất, kích thước ảnh gốc khuyến khích sử dụng theo tỷ lệ 2:3!
                          </p>
                        </div>
                      </el-popover>
                      <!-- <p class="noti">Lưu ý: Hình ảnh sau khi đăng tải sẽ được thay đổi kích thước để hiển thị phù hợp trên giao diện ứng dụng Du lịch Việt Nam an toàn.
                        Để chất lượng hình ảnh tối ưu nhất, kích thước ảnh gốc khuyến khích sử dụng theo tỷ lệ 2:3!</p> -->
                    </b-col>
                    <b-col md="4" xl="3" class="text-center mt-2" v-for="(item,index) in mData.dataForm.listImageUrl" :key="item.name">
                      <div class="position-css">
                        <!-- <div class="bg-image" :style="`background-image: url(${item.url.replace('&r=clip&w=400&h=600&ha=center','')});`"> -->
                          <el-image
                            fit="cover"
                            class="el-image-css"
                            :src="item.url"
                            :preview-src-list="mData.dataDefault.listAlbumImage"
                            :lazy="true"
                            v-if="!fn_checkVideo(item)"
                          >
                            <!-- <img :src="item.url.replace('&r=clip&w=400&h=600&ha=center','')" alt="" style="z-index:9999;"> -->
                            <div slot="error" class="el-image__error">
                              <span class="small" style="line-height: 1rem">{{
                                item.name
                              }}</span>
                            </div>
                          </el-image>
                        <!-- </div> -->
                        <div style="position: relative; cursor: pointer;" v-if="fn_checkVideo(item)" @click="fn_playVideo(item)">
                          <video
                            class="video-css"
                          >
                            <source
                              :src="item.url"
                              :type="fn_changeType(item.type)"
                            />
                          </video>
                          <div class="play-icon-custom">
                            <i class="fa fa-play play-icon-css" aria-hidden="true"></i>
                          </div>
                        </div>
                        <el-tooltip class="item" effect="dark" content="Click để xoá" placement="top-end">
                          <div class="remove-icon c-ponit" @click="fn_uploadRemoveFile(item.anh_id)">
                            <el-image
                              style="width: 100%;"
                              src="img/remove_icon.png"
                              fit="cover">
                            </el-image>
                          </div>
                        </el-tooltip>
                        <el-form-item class="text-left mb-4 margin-auto" label="Chú thích" :prop="'listImageUrl['+index+'].tieu_de'">
                          <el-input
                            @change="saveTemporaryAlbum"
                            class="mt-2"
                            type="textarea"
                            :rows="3"
                            maxlength="150"
                            show-word-limit
                            v-model="
                              item.tieu_de
                            "
                            clearable
                            @input="forceUpdateUI"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </b-col>
                    <b-col md="4" xl="3">
                      <el-form-item class="mb-3" prop="">
                        <el-upload
                          action
                          :auto-upload="false"
                          :show-file-list="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AlbumAnh.limit"
                          :accept="mData.fileUploadOption.AlbumAnh.accept"
                          :on-change="fn_uploadChangeAlbumAnh"
                          v-if="!mData.disableUpload"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <label class="label-infomation">THÔNG TIN CHI TIẾT</label>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Giới thiệu" prop="noiDungHienThiFilter.gioi_thieu">
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="
                            mData.dataForm.noiDungHienThiFilter.gioi_thieu
                          "
                          clearable
                          @input="forceUpdateUI"
                          @change="saveTemporaryInformationDetail"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item class="mb-3" label="Ảnh" prop="noiDungHienThiFilter.anh_id">
                        <el-upload
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhThongTin.limit"
                          :accept="mData.fileUploadOption.AnhThongTin.accept"
                          :on-change="fn_uploadChangeAnhThongTin"
                          :on-preview="fn_uploadPreviewAnhThongTin"
                          :on-remove="fn_uploadRemoveAnhThongTin"
                          :on-exceed="fn_uploadExceedAnhThongTin"
                          :file-list="mData.fileUploadOption.AnhThongTin.fileList"
                          :class="[mData.fileUploadOption.AnhThongTin.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhThongTin.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhThongTin.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Nội dung" prop="noiDungHienThiFilter.noi_dung">
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="
                            mData.dataForm.noiDungHienThiFilter.noi_dung
                          "
                          clearable
                          @input="forceUpdateUI"
                          @change="saveTemporaryInformationDetail"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col class="text-center mb-2">
                      <el-button
                        type="info"
                        plain
                        @click="fn_submitForm('update',mData.dataForm.ngon_ngu)"
                        v-ladda
                        >{{aLang.c_update}}</el-button
                      >
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <!-- <el-form-item class="text-center mt-3">
            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div style="position: fixed; width: 100%; height: 100%; background: rgba(80, 67, 67, 0.79); top: 0; left: 0; z-index: 99999;" v-if="mData.dataDefault.dialogVideo.show">
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); max-width: 80%, max-height: 80%;">
        <video autoplay controls class="video-control">
          <source :src="mData.dataDefault.dialogVideo.src" :type="mData.dataDefault.dialogVideo.type">
        </video>
      </div>
      <div style="position: absolute; right: 20px; top: 45px; cursor: pointer;" @click="fn_closeDialogVideo()">
        <i class="fa fa-times" style="font-size: 36px; color: #ffffff;" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import DangKyDDATModel from '@/views/admin/DangKyDDAT/DangKyDDATModel';
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import MapComponent from "../../../component/MapComponent";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CommuneApi from "../../../moduleApi/CommuneApi";
import SurveyApi from "../../../moduleApi/SurveyApi";
import MapboxComponentH300 from '@/component/MapboxComponentH300'
import ValidService from '../../../service/ValidService';

export default {
  components: {
    MapComponent,
    MapboxComponentH300
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        hoat_dong: false,
        ngung_hoat_dong: true,
        viewMode: "detail",
        moduleName: "DangKyDDAT",
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(DangKyDDATModel.tableRules),
        dataDefault: {
          roles: DataService.rolesInForm,
          listGioiTinh: DataService.gioiTinh,
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          listLoaiHinh: MethodService.copyObject(DataService.loaiHinhRegister),
          listTieuChiAnToan: [],
          listImageUrl: [],
          showMap: false,
          listNgonNgu: DataService.Languages,
          dialogVideo: {
            show: false,
            src: "",
            type: ""
          }
        },
        albumAnhFilter: [{
          anh_id: undefined,
          tieu_de: undefined,
        }],
        dataForm: MethodService.copyObject(DangKyDDATModel.dataForm),
        dataFormOther: MethodService.copyObject(
          DangKyDDATModel.dataFormOther
        ),
        validForm: {
          "noiDungHienThiFilter.gioi_thieu":[],
          "noiDungHienThiFilter.noi_dung":[],
          "noiDungHienThiFilter.anh_id":[],
        },
        validFormOther: DangKyDDATModel.validFormOther,
        fileUploadOption: {
          //MethodService.copyObject(DangKyDDATModel.dataFormOther.fileUploadOption),
          AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          },
          AnhGiayTo: {
            limit: null,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          },
          AlbumAnh: {
            limit: null,
            accept: ".jpg, .png, .jpeg, .mp4, .avi, .mov",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          AnhThongTin: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          }
        },
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem"
        },
        mapDataObject: {
          value: [107.9, 14.01667],
          geoJson: {
            type: "",
            coordinates: []
          }
        },
        notAllowToChange: false,
        disableUpload: false
      },
      typeVideo: ["mp4", "avi", "mov"],
      typeImage: ["jpg", 'png', "jpeg"],
      typeAccept: ["mp4", "avi", "mov", "jpg", 'png', "jpeg"]
    };
  },
  methods: {

    fn_go() {
      this.$router.go(-1);
    },
    async fn_initTable() {
      let currentUser = MethodService.getCurrentUser();

      let dataFilter = {
        filters: "nguoi_tao_id:in:" + currentUser.id,
        // this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch,
          },
        }).catch(()=>{});
      }
      DiemDenAnToanApi.clearCache();
      let res = await DiemDenAnToanApi.list(dataFilter);
      if (res.result && res.result.length > 0) {
        let resGiayTo = [];
        let resDiaChi = [];
        let resNguoiDaiDien = [];
        let resForm = [];
        let hoatDong = {};
        if(res.result[0].hoat_dong  == undefined || res.result[0].hoat_dong.ngung_hoat_dong == undefined){
          this.mData.dataForm.hoat_dong = {ngung_hoat_dong: false}
        }else{
          this.mData.dataForm.hoat_dong.ngung_hoat_dong =  res.result[0].hoat_dong.ngung_hoat_dong;
        }
        if(res.result[0].hoat_dong == undefined || res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi == undefined){
          this.mData.notAllowToChange = false;
        }else{
          let todayTime = new Date().getTime();
          let lastTimeChange = new Date(res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi).getTime();
          let totalTimeChange = (todayTime -  lastTimeChange)/1000/60/60/24;

          if(totalTimeChange < 7){
            this.mData.notAllowToChange = true;
          }else{
            this.mData.notAllowToChange = false;
          }
        }
        if (res.result[0].thong_tin_chung && res.result[0].thong_tin_chung.anh) {
          let data = {
            id: res.result[0].thong_tin_chung.anh,
            name: res.result[0].thong_tin_chung.anh,
            url: ExtensionService.urlSurveyImg + res.result[0].thong_tin_chung.anh
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList = [];
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }

        if (
          res.result[0].thong_tin_chung &&
          res.result[0].thong_tin_chung.giay_to &&
          res.result[0].thong_tin_chung.giay_to.scan
        ) {
          var data = [];
          var listImage = [];
          for (
            let i = 0;
            i < res.result[0].thong_tin_chung.giay_to.scan.length;
            i++
          ) {
            let fileInfo = await SurveyApi.getFile(
              res.result[0].thong_tin_chung.giay_to.scan[i]
            );
            let item = {};
            if (fileInfo.result) {
              item = fileInfo.result;
            } else {
              item = {
                id: res.result[0].thong_tin_chung.giay_to.scan[i],
                name: res.result[0].thong_tin_chung.giay_to.scan[i]
              };
            }
            item.url =
              ExtensionService.urlSurveyImg +
              res.result[0].thong_tin_chung.giay_to.scan[i];
            let url =
              ExtensionService.urlSurveyImg +
              res.result[0].thong_tin_chung.giay_to.scan[i];
            data.push(item);
            listImage.push(url);
          }
          this.mData.fileUploadOption.AnhGiayTo.fileList = data;
          this.mData.dataForm.listImageUrl = listImage;
        }
        if (
          res.result[0].thong_tin_chung.giay_to &&
          res.result[0].thong_tin_chung.giay_to != null
        ) {
          resGiayTo = MethodService.checkDifferentObject(
            MethodService.copyObject(DangKyDDATModel.dataFormOther.giay_to),
            res.result[0].thong_tin_chung.giay_to
          );
        } else {
          resGiayTo = MethodService.copyObject(
            DangKyDDATModel.dataFormOther.giay_to
          );
        }
        if (
          res.result[0].du_lieu_khai_bao &&
          res.result[0].du_lieu_khai_bao.giay_to_ngay_cap
        ) {
          resGiayTo.ngay_cap = MethodService.formatDate(
            res.result[0].du_lieu_khai_bao.giay_to_ngay_cap,
            "date"
          );
        }

        this.mData.dataFormOther.giay_to = resGiayTo;

        if (
          res.result[0].thong_tin_chung &&
          res.result[0].thong_tin_chung.dia_chi &&
          res.result[0].thong_tin_chung.dia_chi.kinh_do &&
          res.result[0].thong_tin_chung.dia_chi.vi_do
        ) {
          this.mData.dataPropMapDiaDiem.lat =
            res.result[0].thong_tin_chung.dia_chi.vi_do;
          this.mData.dataPropMapDiaDiem.lng =
            res.result[0].thong_tin_chung.dia_chi.kinh_do;
          this.mData.dataPropMapDiaDiem.showMap = true;

          let coordinate = [
            res.result[0].thong_tin_chung.dia_chi.kinh_do,
            res.result[0].thong_tin_chung.dia_chi.vi_do
          ];
          this.mData.mapDataObject.value = coordinate;
          // console.log(coordinate);
          this.mData.mapDataObject.geoJson.type = "Point";
          this.mData.mapDataObject.geoJson.coordinates = coordinate;
          this.mData.dataDefault.showMap = true;
        }
        if (
          res.result[0].thong_tin_chung.dia_chi &&
          res.result[0].thong_tin_chung.dia_chi != null
        ) {
          resDiaChi = MethodService.checkDifferentObject(
            MethodService.copyObject(DangKyDDATModel.dataFormOther.dia_chi),
            res.result[0].thong_tin_chung.dia_chi
          );
        } else {
          resDiaChi = MethodService.copyObject(
            DangKyDDATModel.dataFormOther.giay_to
          );
        }

        this.mData.dataFormOther.dia_chi = resDiaChi;

        if (
          res.result[0].thong_tin_chung &&
          res.result[0].thong_tin_chung.dia_chi &&
          res.result[0].thong_tin_chung.dia_chi.tinh_id
        ) {
          let resProvince = await ProvinceApi.findById(
            res.result[0].thong_tin_chung.dia_chi.tinh_id
          );
          this.mData.dataDefault.listProvince.push(resProvince.result);
        }

        if (
          res.result[0].thong_tin_chung &&
          res.result[0].thong_tin_chung.dia_chi &&
          res.result[0].thong_tin_chung.dia_chi.xa_id
        ) {
          let resCommune = await CommuneApi.findById(
            res.result[0].thong_tin_chung.dia_chi.xa_id
          );
          this.mData.dataDefault.listCommune.push(resCommune.result);
        }

        if(res.result[0].hoat_dong  == undefined){
          hoatDong = {ngung_hoat_dong:false};
        }else{
          hoatDong = res.result[0].hoat_dong;
          // hoatDong.ngung_hoat_dong = res.result[0].hoat_dong.ngung_hoat_dong;
          // resForm.hoat_dong.ngung_hoat_dong =  res.result[0].hoat_dong.ngung_hoat_dong;
        }
        if (
          res.result[0].thong_tin_chung.nguoi_dai_dien &&
          res.result[0].thong_tin_chung.nguoi_dai_dien != null
        ) {
          resNguoiDaiDien = MethodService.checkDifferentObject(
            MethodService.copyObject(
              DangKyDDATModel.dataFormOther.nguoi_dai_dien
            ),
            res.result[0].thong_tin_chung.nguoi_dai_dien
          );
        } else {
          resNguoiDaiDien = MethodService.copyObject(
            DangKyDDATModel.dataFormOther.giay_to
          );
        }

        this.mData.dataFormOther.nguoi_dai_dien = resNguoiDaiDien;

        if (
          res.result[0].thong_tin_chung.nguoi_dai_dien &&
          res.result[0].thong_tin_chung.nguoi_dai_dien != null
        ) {
          resForm = MethodService.checkDifferentObject(
            MethodService.copyObject(DangKyDDATModel.dataForm),
            res.result[0]
          );
        } else {
          resForm = MethodService.copyObject(DangKyDDATModel.dataForm);
        }

        let tenLoai = this.mData.dataDefault.listLoaiHinh.find(
          element => element.code == resForm.loai_diem_den
        );
        if (tenLoai) {
          resForm.ten_loai_diem_den = tenLoai.text;
        } else {
          resForm.ten_loai_diem_den = "";
        }

        if (res.result[0].du_lieu_khai_bao) {
          let tieuChi1 = res.result[0].du_lieu_khai_bao.tieuchi1
            ? res.result[0].du_lieu_khai_bao.tieuchi1
            : null;
          let tieuChi2 = res.result[0].du_lieu_khai_bao.tieuchi2
            ? res.result[0].du_lieu_khai_bao.tieuchi2
            : null;
          let tieuChi3 = res.result[0].du_lieu_khai_bao.tieuchi3
            ? res.result[0].du_lieu_khai_bao.tieuchi3
            : null;
          let tieuChi4 = res.result[0].du_lieu_khai_bao.tieuchi4
            ? res.result[0].du_lieu_khai_bao.tieuchi4
            : null;
          let tieuChi5 = res.result[0].du_lieu_khai_bao.tieuchi5
            ? res.result[0].du_lieu_khai_bao.tieuchi5
            : null;
          // debugger;
          let arrTieuChi1 = tieuChi1 == null ? [] : tieuChi1.split("\n");
          let arrTieuChi2 = tieuChi2 == null ? [] : tieuChi2.split("\n");
          let arrTieuChi3 = tieuChi3 == null ? [] : tieuChi3.split("\n");
          let arrTieuChi4 = tieuChi4 == null ? [] : tieuChi4.split("\n");
          let arrTieuChi5 = tieuChi5 == null ? [] : tieuChi5.split("\n");

          let tieuChi = arrTieuChi1
            .concat(arrTieuChi2)
            .concat(arrTieuChi3)
            .concat(arrTieuChi4)
            .concat(arrTieuChi5);

          this.mData.dataDefault.listTieuChiAnToan = tieuChi;
        }
        // debugger
        resForm.hoat_dong = hoatDong;
        this.mData.dataForm = resForm;

      }
      // debugger
      console.log("this.mData.dataForm",this.mData.dataForm);
      this.fn_changeLanguage(this.mData.dataForm.ngon_ngu);
    },

    //Chuyển trạng thái hoạt động
    fn_chuyenTrangThaiHoatDong(trangThai){
      let message = "";
      if(trangThai){
        message = '<p>Bạn có chắc muốn chuyển trạng thái thành CƠ SỞ TẠM NGỪNG HOẠT ĐỘNG hay không?</p>' +
                    '<p>Lưu ý: Bạn chỉ có thể chuyển lại trạng thái thành hoạt động sau ít nhất 7 ngày kể từ khi thực hiện chuyển đổi này!</p>';
      }else{
        message = '<p>Bạn có chắc muốn chuyển trạng thái thành HOẠT ĐỘNG hay không?</p>'+
                    '<p>Lưu ý: Bạn chỉ có thể chuyển lại trạng thái thành ngừng hoạt động sau ít nhất 7 ngày kể từ khi thực hiện chuyển đổi này!</p>';
      }
      this.$confirm( message, '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning",
      })
      .then(async () => {
        let data = {
          id: this.mData.dataForm.id,
          hoat_dong: {
            ngung_hoat_dong: trangThai
          }
        };
        try {
          console.log("data",data);
          await DiemDenAnToanApi.updateActive(data);
          window.location.href = "admin/DangKyDDAT/list";
        } catch (error) {
          console.log('ERROR : ',error.toString());
        }
        this.fn_initDataDefault();
        this.$forceUpdate();
      })
      .catch(() => {
        this.mData.dataForm.hoat_dong.ngung_hoat_dong = !trangThai;
      });
    },
    async fn_initDataDefault() {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "daily") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-daily",
          params: { id: row.id },
        });
      }
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.thong_tin_chung.anh = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "anhDaiDien")
        .then(res => {
          this.mData.dataForm.thong_tin_chung.anh = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_uploadRemoveAnhGiayTo(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataForm.thong_tin_chung.giay_to.scan = data;
    },
    fn_uploadChangeAnhGiayTo(file, fileList) {
      ExtensionService.upload(file, "anhScan")
        .then(res => {
          this.mData.dataForm.thong_tin_chung.giay_to.scan.push(res.result);
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.AnhGiayTo.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhGiayTo(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhGiayTo.limit} file`
      );
    },
    fn_uploadPreviewAnhGiayTo(file) {
      this.mData.fileUploadOption.AnhGiayTo.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhGiayTo.dialogVisible = true;
    },

    fn_addLatLngDiaDiem(lat, lng) {
      this.mData.dataForm.thong_tin_chung.dia_chi.vi_do = lat;
      this.mData.dataForm.thong_tin_chung.dia_chi.kinh_do = lng;
    },

    fn_getDataFromMapboxComponent(value) {
      // debugger
      // console.log(value);
      this.mData.mapDataObject = value;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_download(file) {
      // this.mData.fileUploadOption.FileDinhKem.dialogImageUrl = file.url;
      // this.mData.fileUploadOption.FileDinhKem.dialogVisible = true;

      window.open(ExtensionService.urlSurveyFile + file.id);
    },

    //upload ảnh
    fn_uploadCheckFileImageSize(file) {
      return MethodService.checkFileSize(file, 10);
    },
    //up load video
    fn_uploadCheckFileVideoSize(file) {
      return MethodService.checkFileSize(file, 50);
    },

    fn_checkTypeFile(fileType){
      return MethodService.checkFileType(fileType);
    },
    fn_uploadChangeAlbumAnh(file, fileList) {
      let fileType = file.name.substr(file.name.length - 4, 4).replace(".","").toLowerCase();
      if(!this.typeAccept.includes(fileType)){
        window.toastr.warning("Định dạng file hỗ trợ mp4, avi, mov, jpg, png, jpeg! Vui lòng tải các file đúng định dạng!");
        return
      }
      let item = {};
      let listImage = [];
      if(this.fn_checkTypeFile(fileType) && this.fn_uploadCheckFileImageSize(file)){
        if(this.fn_uploadCheckFileVideoSize(file)){
          this.mData.albumAnhFilter = this.mData.dataForm.listImageUrl;
          if(!this.fn_checkCountFile(this.mData.albumAnhFilter, fileType)){
            return
          }
          ExtensionService.upload(file, "anhAlbum")
          .then((res) => {
            this.mData.albumAnhFilter.push({anh_id:res.result, tieu_de: undefined, type: fileType, ngon_ngu: this.mData.dataForm.ngon_ngu});
            for (
              let i = 0;
              i < this.mData.albumAnhFilter.length;
              i++
            ) {
              this.mData.albumAnhFilter[i].url = ExtensionService.urlImg + this.mData.albumAnhFilter[i].anh_id + "&r=clip&w=400&h=600&ha=center";
              item = {
                name: this.mData.albumAnhFilter[i].anh_id,
                anh_id: this.mData.albumAnhFilter[i].anh_id,
                ngon_ngu: this.mData.dataForm.ngon_ngu,
                tieu_de: this.mData.albumAnhFilter[i].tieu_de,
                type: this.mData.albumAnhFilter[i].type
              };
              item.url =
                ExtensionService.urlImg +
                this.mData.albumAnhFilter[i].anh_id +  (this.typeImage.includes(item.type) ? "&r=clip&w=400&h=600&ha=center" : "");
              listImage.push(item);
            }
            this.mData.dataForm.listImageUrl = listImage;
            this.saveTemporaryAlbum();
            this.fn_filterImageUrl(this.mData.albumAnhFilter);
            this.fn_disableUploadFile(this.mData.dataForm.listImageUrl);
          })
          .catch(() => {});
        }
      }else{
        if(this.typeVideo.includes(fileType)){
          window.toastr.warning("Chỉ tải lên video không quá 50MB");
        }else{
          window.toastr.warning("Chỉ tải lên ảnh không quá 10MB");
        }

      }
    },
    saveTemporaryAlbum(){
      console.log("this.mData.dataForm.listImageUrl",this.mData.dataForm.listImageUrl);
      let arrIndex = [];
      this.mData.dataForm.album.filter((e , index) => {
        if(e.ngon_ngu == this.mData.dataForm.ngon_ngu){
          arrIndex.push(index);
          return e;
        }
      });
      for(let i = arrIndex.length-1; i >= 0; i--){
        this.mData.dataForm.album.splice(arrIndex[i],1);
      }
      for(let i=0; i < this.mData.dataForm.listImageUrl.length; i++){
        this.mData.dataForm.album.push(this.mData.dataForm.listImageUrl[i]);
      }
    },
    saveTemporaryInformationDetail(){
      console.log("this.mData.dataForm.noiDungHienThiFilter",this.mData.dataForm.noiDungHienThiFilter);
      let thongTin = this.mData.dataForm.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataForm.ngon_ngu);
      if(!thongTin){
        this.mData.dataForm.noi_dung_hien_thi.push(this.mData.dataForm.noiDungHienThiFilter)
      }else {
        this.mData.dataForm.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataForm.ngon_ngu).gioi_thieu = this.mData.dataForm.noiDungHienThiFilter.gioi_thieu;
        this.mData.dataForm.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataForm.ngon_ngu).anh_id = this.mData.dataForm.noiDungHienThiFilter.anh_id;
        this.mData.dataForm.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataForm.ngon_ngu).noi_dung = this.mData.dataForm.noiDungHienThiFilter.noi_dung;
      }
    },
    fn_uploadRemoveAnhThongTin(file, fileList) {
      this.mData.dataForm.noiDungHienThiFilter.anh_id = null;
      this.mData.fileUploadOption.AnhThongTin.fileList = [];
      this.saveTemporaryInformationDetail();
      this.$refs["myForm"].validateField("noiDungHienThiFilter.anh_id");
    },
    fn_uploadChangeAnhThongTin(file, fileList) {
      // let fileType = file.name.substr(file.name.length - 4, 4).replace(".","").toLowerCase();
      // if(!this.typeImage.includes(fileType)){
      //   window.toastr.warning("Định dạng file hỗ trợ jpg, png, jpeg! Vui lòng tải các file đúng định dạng!");
      //   return
      // }
      ExtensionService.upload(file, "anhHienThi")
        .then(res => {
          this.mData.dataForm.noiDungHienThiFilter.anh_id = res.result;
          this.mData.fileUploadOption.AnhThongTin.fileList = fileList;
          this.saveTemporaryInformationDetail();
          this.$refs["myForm"].validateField("noiDungHienThiFilter.anh_id");
        })
        .catch(error => {
          this.$refs["myForm"].validateField("noiDungHienThiFilter.anh_id");
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhThongTin(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhThongTin.limit} file`
      );
    },
    fn_uploadPreviewAnhThongTin(file) {
      this.mData.fileUploadOption.AnhThongTin.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhThongTin.dialogVisible = true;
    },
    fn_changeLanguage(lang){
      this.mData.fileUploadOption.AnhThongTin.fileList = [];
      this.mData.dataForm.noiDungHienThiFilter = this.mData.dataForm.noi_dung_hien_thi.find(e => e.ngon_ngu == lang);
      this.fn_album(lang);
      if(!this.mData.dataForm.noiDungHienThiFilter) {
        this.mData.dataForm.noiDungHienThiFilter =  {};
      }
      if (
        this.mData.dataForm.noiDungHienThiFilter &&
        this.mData.dataForm.noiDungHienThiFilter.anh_id
      ) {
        let dataImg = {
          id: this.mData.dataForm.noiDungHienThiFilter.anh_id,
          name: this.mData.dataForm.noiDungHienThiFilter.anh_id,
          url: ExtensionService.urlImg + this.mData.dataForm.noiDungHienThiFilter.anh_id + "&r=square&w=512"
        };
        this.mData.fileUploadOption.AnhThongTin.fileList = [];
        this.mData.fileUploadOption.AnhThongTin.fileList.push(dataImg);
      }
      this.mData.dataForm.noiDungHienThiFilter.ngon_ngu = lang;
      // console.log("this.mData.dataForm.noiDungHienThiFilter",this.mData.dataForm.noiDungHienThiFilter);
    },
    fn_album(lang){
      this.mData.albumAnhFilter = this.mData.dataForm.album.filter(e => e.ngon_ngu == lang);
      this.fn_disableUploadFile(this.mData.albumAnhFilter);
      if(
        this.mData.albumAnhFilter
      ){
        let listImage = [];
        for (
          let i = 0;
          i < this.mData.albumAnhFilter.length;
          i++
        ) {
          this.mData.albumAnhFilter[i].url = ExtensionService.urlImg + this.mData.albumAnhFilter[i].anh_id +"&r=clip&w=400&h=600&ha=center";
          let item = {};
          item = {
            name: this.mData.albumAnhFilter[i].anh_id,
            anh_id: this.mData.albumAnhFilter[i].anh_id,
            tieu_de: this.mData.albumAnhFilter[i].tieu_de,
            ngon_ngu: lang,
            type: this.mData.albumAnhFilter[i].type
          };
          item.url =
            ExtensionService.urlImg +
            this.mData.albumAnhFilter[i].anh_id + (this.typeImage.includes(item.type) ? "&r=clip&w=400&h=600&ha=center" : "");
          listImage.push(item);
        }
        this.mData.dataForm.listImageUrl = listImage;
        this.fn_filterImageUrl(this.mData.albumAnhFilter);
      }
    },
    fn_submitForm(type,lang) {
      this.$refs["myForm"].validate(async (valid) => {
        let data = {};
        data.id = this.mData.dataForm.id;
        data.noi_dung_hien_thi = this.mData.dataForm.noi_dung_hien_thi;
        data.album = this.mData.dataForm.album.filter(x => x.anh_id);
        if (valid) {
          if (type == "update") {
            let arrIndex = [];
            let thongTin = data.noi_dung_hien_thi.find(e => e.ngon_ngu == lang);
            data.album.filter((e , index) => {
              if(e.ngon_ngu == lang){
                arrIndex.push(index);
                return e;
              }
            });
            if(!thongTin){
              data.noi_dung_hien_thi.push(this.mData.dataForm.noiDungHienThiFilter)
            }else {
              data.noi_dung_hien_thi.find(e => e.ngon_ngu == lang).gioi_thieu = this.mData.dataForm.noiDungHienThiFilter.gioi_thieu;
              data.noi_dung_hien_thi.find(e => e.ngon_ngu == lang).anh_id = this.mData.dataForm.noiDungHienThiFilter.anh_id;
              data.noi_dung_hien_thi.find(e => e.ngon_ngu == lang).noi_dung = this.mData.dataForm.noiDungHienThiFilter.noi_dung;
            }
            for(let i = arrIndex.length-1; i >= 0; i--){
              data.album.splice(arrIndex[i],1);
            }
            for(let i=0; i < this.mData.dataForm.listImageUrl.length; i++){
              data.album.push(this.mData.dataForm.listImageUrl[i]);
            }
            console.log("data update",data);
            await DiemDenAnToanApi.update(data);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_filterImageUrl(arrImage){
      let imageExtension = ["jpg","jpeg","png","gif","bmp","tiff","webp","svg"];
      let imageUrls = arrImage.filter(x => typeof(x.type) == "string" && imageExtension.includes(x.type.toLowerCase())).map((a) => a.url);
      this.mData.dataDefault.listAlbumImage = imageUrls;
      // this.mData.dataDefault.listAlbumImage.forEach(item => {
      //   return item = item.replace("&r=clip&w=400&h=600&ha=center","");
      // })
      for (let i = 0; i < this.mData.dataDefault.listAlbumImage.length; i++) {
        this.mData.dataDefault.listAlbumImage[i] = this.mData.dataDefault.listAlbumImage[i].replace("&r=clip&w=400&h=600&ha=center","");
      }
      console.log("this.mData.dataDefault.listAlbumImage",this.mData.dataDefault.listAlbumImage);
      // for (let i = 0; i <  this.mData.dataForm.listImageUrl.length; i++) {
      //   this.mData.validForm["listImageUrl["+i+"].tieu_de"] = [
      //     ValidService.required,
      //     ValidService.checkSpaceString,
      //   ]
      // }
    },
    fn_checkCountFile(fileList, typeFile){
      if(this.typeVideo.includes(typeFile)){
        if(fileList.filter(e => this.typeVideo.includes(e.type)).length == 3){
          window.toastr.info("Chỉ tải lên tối đa 3 video");
          return false;
        }else{
          return true;
        }
      }else{
        if(fileList.filter(e => !this.typeVideo.includes(e.type)).length == 10){
          window.toastr.info("Chỉ tải lên tối đa 10 ảnh");
          return false;
        }else{
          return true;
        }
      }
    },
    fn_disableUploadFile(fileList){
      if(fileList.length == 13){
        this.mData.disableUpload = true;
      }else{
        this.mData.disableUpload = false;
      }
    },
    fn_checkVideo(item) {
      if (item.type && this.typeVideo.includes(item.type)) {
        return true;
      }
      return false;
    },
    fn_changeType(extension) {
      if (extension) {
        return "video/" + extension.replace(".", "");
      }
      return "";
    },
    fn_playVideo(item) {
      this.mData.dataDefault.dialogVideo.src = item.url;
      this.mData.dataDefault.dialogVideo.type = this.fn_changeType(item.type);
      this.mData.dataDefault.dialogVideo.show = true;
    },
    fn_closeDialogVideo() {
      this.mData.dataDefault.dialogVideo.src = "";
      this.mData.dataDefault.dialogVideo.type = "";
      this.mData.dataDefault.dialogVideo.show = false;
    },
    fn_uploadRemoveFile(fileId){
      this.mData.dataForm.listImageUrl = this.mData.dataForm.listImageUrl.filter(e => e.anh_id != fileId);
      this.saveTemporaryAlbum();
      this.fn_disableUploadFile(this.mData.dataForm.listImageUrl);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  },
  created: function() {
    this.fn_initTable();
  },
  mounted: function() {},
  computed: {
    options() {
      return {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      };
    }
  },
};
</script>
<style lang="scss">
.d-flex{
  display: flex;
  flex-direction: column;
  // justify-content: ;
  // align-items: center;
}
.warning-text{
  color : rgb(22, 152, 252) !important;
  text-decoration: underline;
  font-size: 10px;
  margin-bottom: 10px;
}
.warning-text:hover{
  // text-decoration: none;
}
.alert-message{
  word-break: initial;
  padding: 5px;
}
::v-deep .el-link {
  display: flex !important;
  justify-content: flex-start !important;
}
::v-deep .el-link--inner {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.margin-auto{
  margin: 0 auto;
}
.form-css{
  display: flex;
  flex-direction: column;
}
.checkbox-inactive{
  line-height: 24px;
}
.checkbox-active >span.el-radio__label{
  text-transform: uppercase;
  // color: rgb(63, 219, 16);
}
.checkbox-active .is-checked+span.el-radio__label{
  text-transform: uppercase;
  // color: rgb(63, 219, 16);
  font-weight: bold;
}
.checkbox-active .is-checked.is-disabled+span.el-radio__label{
  color: #409EFF;
}
.checkbox-inactive >span.el-radio__label{
  text-transform: uppercase;
  // color: red;
}
.checkbox-inactive .is-checked+span.el-radio__label{
  text-transform: uppercase;
  // color: red;
  font-weight: bold;
}
.checkbox-inactive .is-checked.is-disabled+span.el-radio__label{
  color: #409EFF;
}
.el-image-css, .video-css{
  height: 170px;
}
.play-icon-custom{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border-radius: 36px;
  background-color: rgba(80, 67, 67, 0.79);
  display: flex;
  align-items: center;
  border: 1px solid rgb(255, 255, 255);
}
.play-icon-css{
    font-size: 20px;
    color: rgb(255, 255, 255);
    font-weight: 100;
    margin-left: 13px;
}
.position-css{
  position: relative;
}
.remove-icon{
  position: absolute;
  top: -5px;
  right: -5px;
  width: 15px;
  height: 15px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 10px;
}
.c-ponit:hover{
  cursor: pointer;
}
.video-control{
  max-height: 100vh;
}
.el-image-viewer__img{
  max-height: 85% !important;
  max-width: 85% !important;
}
.el-image-viewer__btn.el-image-viewer__close{
  top: 50px !important;
}
.el-image-viewer__btn.el-image-viewer__actions{
  bottom: 50px !important;
}
.el-textarea .el-input__count{
  bottom: -7px;
  background: transparent;
}
.noti{
  font-style: italic;
}
.bg-image{
  background-size: cover;
  background-repeat: no-repeat;
  // opacity: 0;
  display: inline;
  z-index: 10;
}
::v-deep .el-popover{
  word-break: inherit !important;
}
@media (max-width: 1750px) {
  .el-image-css, .video-css{
    height: 125px;
  }
}
@media (max-width: 1500px) {
  .el-image-css, .video-css{
    height: 100px;
  }
}
@media (max-width: 1380px) {
  .video-control{
    max-height: 57vh;
  }
}
@media (max-width: 1240px) {
  .el-image-css, .video-css{
    height: 80px;
  }
}
@media (max-width: 1105px) {
  .video-control{
    max-height: 40vh;
  }
}
@media (max-width: 768px) {
  .el-image-css, .video-css{
    height: 168px;
  }
  .position-css{
    max-width: 430px;
    margin: 0 auto;
  }
  .margin-auto{
    max-width: 430px;
  }
  .video-control{
    max-height: 23vh;
  }
}
@media (max-width: 440px) {
  .el-image-css, .video-css{
    height: 130px;
  }
  .video-control{
    max-height: 20vh;
  }
}
@media (max-width: 350px) {
  .el-image-css, .video-css{
    height: 90px;
  }
  .video-control{
    max-height: 14vh;
  }
}
</style>
